
import moment from "moment";

export class EvalFormat {
    static trim(str, n) {
        let len = n||30;

        let before = [...str];
        let after = [...str].slice(0, len);
        let trimmed = after.join("");

        if (before.length > after.length)
            trimmed += "..";
        return trimmed;
    }

    // takes milliseconds
    static toUnitOfTime(value, precision) {

        if (isNaN(value))
            return "--";

        let d = value;
        precision = precision||0;

        if (d < 1000)
            return d.toFixed(precision).toLocaleString() + " ms";

        // convert to seconds
        d = d/1000;

        if (d < 60)
            return d.toFixed(precision).toLocaleString() + " sec";

        d /= 60;
        if (d < 60)
            return d.toFixed(precision).toLocaleString() + " min";

        d /= 60;
        if (d < 24)
            return d.toFixed(precision).toLocaleString() + " hr";

        d /= 24;
        return d.toFixed(precision).toLocaleString() + " day";
    }

    static timeElapsed(time) {
        let now = moment()
        let timeMoment = moment(new Date(time));
        let seconds = now.diff(timeMoment, "seconds");
        let ms = seconds*1000;
        return EvalFormat.toUnitOfTime(ms);
    }
}